import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=516f29a3&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516f29a3')) {
      api.createRecord('516f29a3', component.options)
    } else {
      api.reload('516f29a3', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=516f29a3&", function () {
      api.rerender('516f29a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2O8L2ShFSGyBz/JS/comp/IncreaseNumber.vue"
export default component.exports